import { useRef } from 'react';

//* Components
import Container from 'components/common/Container';
import Image from 'components/common/Image';
import Text from 'components/common/Text';
import Button from 'components/common/Button';
import Animate from 'components/common/Animate';

//* Style
import InterestingFactStyle from './style';

const InterestingFact = ({ title, description, image, className, isSection = true, url, buttonText }) => {
	//! Refs
	const factContainer = useRef();
	const factContent = useRef();

	return (
		<Animate
			stagger={0.2}
			params={{ bottomToTop: [factContainer, factContent] }}>
			<Container
				section={isSection}
				full>
				<InterestingFactStyle
					className={`${className || ''}  ${isSection ? 'section' : ''}`}
					ref={factContainer}>
					<Image
						objectFit={'cover'}
						src={image?.url}
						alt={image?.alt}
						className={'interesting-fact-image'}
					/>

					<Container>
						<div
							className='interesting-fact-content'
							ref={factContent}>
							<Text
								className={'h3 font-ping-bold'}
								text={title}
							/>
							<Text
								className={'interesting-fact-content-description p font-helvetica'}
								text={description}
							/>
							{url && (
								<Button
									className='interesting-fact-button'
									text={buttonText || 'learnMore'}
									type={'lottie'}
									url={url}
								/>
							)}
						</div>
					</Container>
				</InterestingFactStyle>
			</Container>
		</Animate>
	);
};

export default InterestingFact;
